import React from 'react'
import { BotzappingWrapperStyled } from './Wrappers.styled'
import { useGetDomains } from 'Features/domainsManagement/api/getDomains'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { useGetUserProfile } from 'Features/userProfile/api/getUserProfile'
import { useGetAccountLogo } from 'Features/accountSettings/api/getAccountLogo'
import type { UserProfileResponse } from '../botMitigation/types/federatedContext'

const useWrappedDomains = () => {
  const query = useGetDomains()
  return () => ({
    data: query.data
      ? {
          httpStatusCode: 200,
          timestamp: new Date().toISOString(),
          result: 'success',
          path: '/domains',
          ...query.data,
        }
      : undefined,
  })
}

const useWrappedPlansDetails = () => {
  const query = useGetPlansDetails()
  return () => ({
    data: { plans: query.data?.plans ?? [] },
  })
}

const useWrappedUserProfile = () => {
  const query = useGetUserProfile()
  return () => ({
    data: query.data ?? ({} as UserProfileResponse),
  })
}

const useWrappedAccountLogo = () => {
  const query = useGetAccountLogo()
  return () => ({
    data: {
      downloadLink: query.data && 'downloadLink' in query.data ? query.data.downloadLink : '',
    },
  })
}

const BotzappingContent = () => {
  const getDomains = useWrappedDomains()
  const getPlansDetails = useWrappedPlansDetails()
  const getUserProfile = useWrappedUserProfile()
  const getAccountLogo = useWrappedAccountLogo()

  return (
    <BotzappingWrapperStyled
      useGetDomains={getDomains}
      useGetPlansDetails={getPlansDetails}
      useGetUserProfile={getUserProfile}
      useGetAccountLogo={getAccountLogo}
    />
  )
}

export const BotzappingRoutes = () => {
  return <BotzappingContent />
}
